/**
 * @generated SignedSource<<04955f922a8c2ab64d39323ce02629a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type HydrantModelInputHydrantModelsQuery$variables = {};
export type HydrantModelInputHydrantModelsQueryVariables = HydrantModelInputHydrantModelsQuery$variables;
export type HydrantModelInputHydrantModelsQuery$data = {
  readonly hydrantModels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly family: {
          readonly id: string;
        };
      };
    }>;
  };
};
export type HydrantModelInputHydrantModelsQueryResponse = HydrantModelInputHydrantModelsQuery$data;
export type HydrantModelInputHydrantModelsQuery = {
  variables: HydrantModelInputHydrantModelsQueryVariables;
  response: HydrantModelInputHydrantModelsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HydrantModelInputHydrantModelsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HydrantModelConnection",
        "kind": "LinkedField",
        "name": "hydrantModels",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HydrantModelEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HydrantModel",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "family",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HydrantModelInputHydrantModelsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HydrantModelConnection",
        "kind": "LinkedField",
        "name": "hydrantModels",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HydrantModelEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HydrantModel",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "family",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3429dca081c6e2137f302b837ae68379",
    "id": null,
    "metadata": {},
    "name": "HydrantModelInputHydrantModelsQuery",
    "operationKind": "query",
    "text": "query HydrantModelInputHydrantModelsQuery {\n  hydrantModels {\n    edges {\n      node {\n        id\n        name\n        family {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "27d89025ea590c6d8daed25b74ec00da";

export default node;
